// src/components/courses/FeatureList.jsx
import React from 'react';
import PropTypes from 'prop-types';

const FeatureList = ({ features }) => {
  return (
    <ul className="list-disc pl-5 text-gray-700 text-sm">
      {features.map((feature, index) => (
        <li key={index} className="mb-1">{feature}</li>
      ))}
    </ul>
  );
};

FeatureList.propTypes = {
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default FeatureList;